/* eslint-disable */

/** unique or primary key constraints on table "argo.media_instance" */
export enum ArgoMediaInstanceConstraint {
  /** unique or primary key constraint on columns "id" */
  MediaInstancePkey = 'media_instance_pkey'
}

/** select columns of table "argo.media_instance" */
export enum ArgoMediaInstanceSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  IsBirthCertificate = 'is_birth_certificate',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Mimetype = 'mimetype',
  /** column name */
  SizeBytes = 'size_bytes',
  /** column name */
  Url = 'url'
}

/** update columns of table "argo.media_instance" */
export enum ArgoMediaInstanceUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  IsBirthCertificate = 'is_birth_certificate',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Mimetype = 'mimetype',
  /** column name */
  SizeBytes = 'size_bytes',
  /** column name */
  Url = 'url'
}

